import type { SourcePageInfoData } from '~/api/interface/landing'

export default function useAppInitData() {
  const config = useRuntimeConfig()
  const source = useSource()

  useAsyncData(async () => {
    const res = await $fetch<SourcePageInfoData>(
      `${config.public.apiCms}/api/screen-pages?populate=deep`
    )

    if (res) {
      source.setInfos(res)
    }

    return res
  })

  return {
    source,
  }
}
